import React from 'react';

import {FormikErrors, withFormik} from 'formik';

import {Constants, Utils} from 'commons';
import {Regex} from 'commons/constants';
import {CreateAccountValues} from 'commons/models';
import InnerFormCreate from './InnerFormCreate';

type Props = {
    title: string;
    isLoading: boolean;
    submitHandler: (values: CreateAccountValues) => void;
};

const FormControl = withFormik<Props, CreateAccountValues>({
    mapPropsToErrors: () => {
        return {rfc: '', email: '', password: '', confirmPassword: ''};
    },
    mapPropsToValues: () => {
        return {rfc: '', email: '', password: '', confirmPassword: ''};
    },
    validateOnBlur: true,
    validateOnChange: true,
    validate: (values: CreateAccountValues) => {
        const errors: FormikErrors<CreateAccountValues> = {};
        if (!values.rfc) {
            errors.rfc = Utils.messageFunctions.getRequiredMessage('RFC');
        } else {
            values.rfc = values.rfc.toUpperCase();
            if (!Regex.NEW_USER_RFC.test(values.rfc)) {
                errors.rfc = Utils.messageFunctions.getRegexMessage('RFC');
            }
        }
        if (!values.email) {
            errors.email = Utils.messageFunctions.getRequiredMessage('Correo electr\u00F3nico');
        } else if (!Regex.EMAIL.test(values.email)) {
            errors.email = Utils.messageFunctions.getRegexMessage('Correo electr\u00F3nico');
        }
        if (!values.password) {
            errors.password = Utils.messageFunctions.getRequiredMessage('Contrase\u00F1a');
        } else if (values.password.length < 8 || values.password.length > 50) {
            errors.password = Utils.messageFunctions.getRangeLengthMessage(
                'Contrase\u00F1a',
                8,
                50
            );
        } else if (!Constants.Regex.PASSWORD.test(values.password)) {
            errors.password = Utils.messageFunctions.getRegexMessage('Contrase\u00F1a');
        }
        if (!values.confirmPassword) {
            errors.confirmPassword = Utils.messageFunctions.getRequiredMessage(
                'Confirmar contrase\u00F1a'
            );
        } else if (values.confirmPassword.length < 8 || values.confirmPassword.length > 50) {
            errors.confirmPassword = Utils.messageFunctions.getRangeLengthMessage(
                'Confirmar contrase\u00F1a',
                8,
                50
            );
        } else if (!Constants.Regex.PASSWORD.test(values.confirmPassword)) {
            errors.confirmPassword = Utils.messageFunctions.getRegexMessage('Contrase\u00F1a');
        }
        if (values.password != values.confirmPassword) {
            errors.confirmPassword = 'Las contrase\u00F1as no coinciden';
        }
        return errors;
    },
    handleSubmit: async (values, actions) => {
        actions.setSubmitting(false);
        await actions.props.submitHandler(values);
    },
})(InnerFormCreate);

function CreateForm(props: Props) {
    const {submitHandler, isLoading, title} = props;
    return <FormControl title={title} submitHandler={submitHandler} isLoading={isLoading} />;
}

export default CreateForm;
